// src/components/LoginScreen.tsx
import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../context/AppContext";
import { ethers } from "ethers";

const LoginScreen: React.FC = () => {
  const { setUserWallet } = useContext(AppContext);
  const navigate = useNavigate();

  // Handler for Passkey login (currently disabled)
  const handlePasskeyLogin = () => {
    alert("Passkey login is coming soon!");
  };

  // Handler for MetaMask login using MetaMask's injected provider.
  const handleMetaMaskLogin = async () => {
    if (!window.ethereum) {
      alert("MetaMask is not installed. Please install MetaMask.");
      return;
    }
    try {
      const provider = new ethers.BrowserProvider(window.ethereum as any);
      await provider.send("eth_requestAccounts", []);
      const signer = await provider.getSigner();
      const address = await signer.getAddress();
      setUserWallet({
        address,
        type: "metamask",
      });
      navigate("/upload");
    } catch (error) {
      console.error("MetaMask login failed", error);
      alert("MetaMask login failed. Please try again.");
    }
  };

  return (
    <div className="card login-card">
      <h2>Select Wallet for Login</h2>
      <div className="wallet-options">
        <div className="wallet-option" onClick={handleMetaMaskLogin}>
          <img
            src="/images/MetaMask_Fox.svg"
            alt="MetaMask"
            className="wallet-image"
          />
          <button className="wallet-button">Login with MetaMask</button>
        </div>
        <div
          className="wallet-option disabled"
          onClick={handlePasskeyLogin}
          style={{ opacity: 0.5, cursor: "not-allowed" }}
        >
          <img
            src="/images/fingerprint.png"
            alt="Passkey"
            className="wallet-image"
          />
          <button className="wallet-button" disabled>
            Login with Passkey (Coming Soon)
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginScreen;
